import { TemplateElement, html, defineElement } from '@webtides/element-js';
import { randomUUID } from "../../webresources-sources/js/util/crypto.js";

/**
 * @property {string} trigger
 * @property {string} placement
 * @property {string} variant
 * @property {string} content
 */
export default class TooltipElement extends TemplateElement {
    uuid = randomUUID();

    constructor() {
        super({ shadowRender: true });
    }

    properties() {
        return {
            trigger: 'hover focus',
            placement: 'top',
            variant: 'light', // light | dark
            content: '',
        };
    }

    connected() {
        this._initTooltip();
    }

    events() {
        return {
            this: {
                mouseover: () => {
                    if (this.trigger.includes('hover')) {
                        this.show();
                    }
                },
                mouseout: () => {
                    if (this.trigger.includes('hover')) {
                        setTimeout(() => {
                            const hoveredTooltip = document.querySelector(`.tooltip-${this.uuid}:hover`);
                            if (!hoveredTooltip) {
                                this.hide();
                            }
                        }, 250);
                    }
                },
                focusin: () => {
                    if (this.trigger.includes('focus')) {
                        this.show();
                    }
                },
                focusout: () => {
                    if (this.trigger.includes('focus')) {
                        this.hide();
                    }
                },
                keydown: (e) => {
                    if (e.key === 'Escape') {
                        this.hide();
                    }
                },
            },
        };
    }

    _initTooltip() {
        const lightTemplate = `<div class="tooltip tooltip-${this.uuid}" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>`;
        const darkTemplate = `<div class="tooltip tooltip-${this.uuid} is-dark" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>`;
        $(this.$refs.tooltip).tooltip({
            trigger: this.trigger,
            placement: this.placement,
            template: this.variant === 'dark' ? darkTemplate : lightTemplate,
            title: this.content,
            html: true,
        });
    }

    show() {
        $(this.$refs.tooltip).tooltip('show');

        if (this.trigger.includes('hover')) {
            const tooltip = document.querySelector(`.tooltip-${this.uuid}`);
            if (tooltip) {
                tooltip.addEventListener('mouseleave', () => {
                    this.hide();
                })
            }
        }
    }

    hide() {
        $(this.$refs.tooltip).tooltip('hide');
    }

    template() {
        return html`<div ref="tooltip"></div>
            <slot></slot> `;
    }
}

defineElement('tooltip-element', TooltipElement);
